export enum ChatWidgetCurrent {
  MESSAGE,
  CHAT,
  OTHER,
  DEFAULT,
}
